import {
	SlideshowFromDirection,
	type SlideshowIndexDirectionsMap,
} from '@fukku/slideshow/types/Slideshow'

/**
 * Calculates the new index based on the current index, direction, and total number of items.
 * Handles wrapping around when reaching the boundaries (0 and nItems-1).
 *
 * @param currentIndex - The current active index
 * @param fromDirection - The direction to move (Left or Right)
 * @param nItems - Total number of items in the slideshow
 * @returns The new index after applying the direction
 */
export const getNewIndexFromDirection = (
	currentIndex: number,
	fromDirection: SlideshowFromDirection,
	nItems: number
): number => {
	const newIndexFromDirections: SlideshowIndexDirectionsMap = {
		[SlideshowFromDirection.Left]:
			currentIndex <= 0 ? nItems - 1 : currentIndex - 1,
		[SlideshowFromDirection.Right]:
			currentIndex >= nItems - 1 ? 0 : currentIndex + 1,
	}

	return newIndexFromDirections[fromDirection]
}
